export function isBodyActive(): boolean {
  return document?.activeElement?.tagName === 'BODY'
}
